var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLock(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.6045 26.2087V30.3337C27.6045 31.7712 26.4378 32.9378 25.0003 32.9378C23.5628 32.9378 22.3962 31.7712 22.3962 30.3337V26.2087C21.6462 25.7503 21.0628 25.0837 20.6462 24.292H6.25033C5.10449 24.292 4.16699 25.2295 4.16699 26.3753V33.7295C4.16699 40.417 9.58366 45.8337 16.2712 45.8337H33.7087C40.417 45.8337 45.8337 40.417 45.8337 33.7295V26.3753C45.8337 25.2295 44.8962 24.292 43.7503 24.292H29.3545C28.9378 25.0837 28.3545 25.7503 27.6045 26.2087Z",
    fill: "#121B26"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M33.7295 4.1665H16.2712C9.58366 4.1665 4.16699 9.58317 4.16699 16.2707V19.0832C4.16699 20.229 5.10449 21.1665 6.25033 21.1665H20.1462C20.6253 18.4165 23.3545 16.4582 26.3337 17.2498C28.0003 17.6873 29.3545 19.0415 29.792 20.7082C29.8337 20.854 29.8337 21.0207 29.8545 21.1665H43.7503C44.8962 21.1665 45.8337 20.229 45.8337 19.0832V16.2707C45.8337 9.58317 40.417 4.1665 33.7295 4.1665Z",
    fill: "#121B26"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLock);
export default __webpack_public_path__ + "static/media/lock.5870ed2db7952ed48b020714a51715ae.svg";
export { ForwardRef as ReactComponent };